<template>
  <mk-drawer
    ref="screenshot"
    :visible.sync="show"
    class="task-screenshot"
    size="415px"
    hide-header
    :before-close="cancel"
  >
    <div class="header">
      <h3>任务截图</h3>
      <i
        class="close iconfont icon-mk-guanbi"
        @click="cancel"
      ></i>
    </div>
    <mk-carousel
      ref="carousel"
      class="carousel"
      trigger="click"
      :autoplay="false"
      :loop="false"
      @change="change"
      @load="initImage"
    >
      <mk-carousel-item
        v-for="(item, indexC) in list"
        :key="indexC"
      >
        <img
          ref="img"
          :src="item.image"
          @load="initImage"
        />
      </mk-carousel-item>
    </mk-carousel>
    <div class="handle">
      <div
        class="prev"
        @click="prev"
      >
        <mk-iconfont
          class="icon"
          :class="prevDisabled ? 'disabled' : ''"
          icon-class="left"
        ></mk-iconfont>
      </div>
      <div class="num">
        {{ index }} /<span>{{ list.length }}</span>
      </div>
      <div
        class="next"
        @click="next"
      >
        <mk-iconfont
          class="icon next"
          :class="nextDisabled ? 'disabled' : ''"
          icon-class="right"
        ></mk-iconfont>
      </div>
    </div>
  </mk-drawer>
</template>
<script>
let that
window.onresize = function () {
  if (that) {
    that.initImage()
  }
}
export default {
  props: {
    show: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      index: 1,
      prevDisabled: true,
      nextDisabled: false,
      imgShowList: []
    }
  },
  created () {
    that = this
    if (this.list.length === 1) {
      this.nextDisabled = true
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    prev () {
      this.$refs.carousel.prev()
    },
    next () {
      this.$refs.carousel.next()
    },
    initImage () {
      let data = this.$refs.img
      if (data instanceof Array) {
        data.forEach((item, index) => {
          let initScale =
            item.parentNode.offsetWidth / item.parentNode.offsetHeight
          let imgScale = item.naturalWidth / item.naturalHeight
          if (imgScale < initScale) {
            item.className = 'colum'
          } else {
            item.className = ''
          }
        })
      }
    },
    change (e) {
      this.index = e + 1
      if (this.index === this.list.length) {
        this.nextDisabled = true
        this.prevDisabled = false
      } else if (this.index === 1) {
        this.nextDisabled = false
        this.prevDisabled = true
      } else {
        this.nextDisabled = false
        this.prevDisabled = false
      }
      this.initImage()
    }
  }
}
</script>
<style lang="scss" scoped>
.task-screenshot {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;

  /deep/ .el-carousel__arrow {
    display: none !important;
  }

  .header {
    line-height: 60px;
    box-shadow: 0 1px 0 0 rgba(232, 232, 232, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    // margin-bottom: 16px;

    h3 {
      font-weight: 500;
      font-size: 16px;
      margin-left: 16px;
    }

    .close {
      font-size: 16px;
      cursor: pointer;
      margin-right: 16px;
      color: #bfbfbf;
    }
  }

  .carousel {
    width: 375px;
    margin: 0 auto;
    // height: 100%;
    overflow-y: auto;
    margin-top: 20px;
  }

  .handle {
    display: flex;
    justify-content: center;
    padding: 20px 0 36px 0;

    .next,
    .prev {
      cursor: pointer;

      .icon {
        color: #262626;
        font-size: 14px;
        font-weight: 500;
      }

      .icon.disabled {
        color: #a1a1a1;
      }
    }

    .prev {
      .icon {
        font-size: 16px;
      }
    }

    .num {
      color: #262626;
      margin: 0 8px;

      span {
        color: #888;
        font-size: 16px;
      }
    }
  }

  /deep/ .el-carousel__container {
    height: calc(100vh - 135px);
    background: #000;
    position: relative;

    img {
      display: block;
      width: 100%;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    img.colum {
      display: block;
      width: auto;
      height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  /deep/ .el-carousel__indicators {
    display: none !important;
  }
}
</style>
